import FileSaver from "file-saver";
import IDBExportImport from "indexeddb-export-import";
import JSZip from "jszip";

function exportarBanco() {
    return new Promise((resolve, reject) => {
        const request = window.indexedDB.open("Inovaclickteste", 1);

        request.onerror = (err) => {
            console.log("error criacao/abertura do banco indexed");
            reject(err);
        };

        request.onsuccess = (event) => {
            let db = event.target.result;
            IDBExportImport.exportToJsonString(db, async function(err, dbJsonString) {
                if (err) {
                    console.error(err);
                    reject(err);
                } else {
                    let zip = new JSZip();
                    zip.file("Inovaclickteste.json", dbJsonString);
                    const zipBlob = await zip.generateAsync({type:"blob", compression: "DEFLATE"});
                    FileSaver.saveAs(zipBlob, "Inovaclickteste.db.zip");
                    resolve();
                }
            });
        };
    });
}

export default exportarBanco;